import Splide from '@splidejs/splide';
import $ from 'jquery';

const buttons = $('.hero__button');

if ($('.hero-area__slider').length > 0) {
  const instance = new Splide('.hero-area__slider', {
    type: 'loop',
    perPage: 1,
    pagination: false,
    arrows: false,
  }).mount();

  instance.on('mounted', () => {
    buttons.removeClass('hero__button--active');
    buttons.eq(0).addClass('hero__button--active');
  });

  instance.on('move', (newIndex) => {
    buttons.removeClass('hero__button--active');
    buttons.eq(newIndex % buttons.length).addClass('hero__button--active');
  });

  buttons.on('mouseover', function () {
    const index = $(this).index();
    if (index < buttons.length) {
      instance.go(index);
    }
  });
}


const updateHeroButtonsInset = () => {
  const bodyWidth = $('body').outerWidth();
  const containerWidth = $('.container').outerWidth();

  const paddingRight = (bodyWidth - containerWidth) / 2;

  $('.hero__buttons--inset').css({
    width: `${bodyWidth}px`,
    right: `${paddingRight}px`,
  });
};

$(window).on('resize', updateHeroButtonsInset);
updateHeroButtonsInset();


